import styles from './SuggestionBanner.module.scss';

interface SuggestionBannerProps {
  logo?: React.ReactNode;
  description: string;
  action: React.ReactNode;
  readMoreButton?: React.ReactNode;
}

export const SuggestionBanner: React.FC<SuggestionBannerProps> = ({
  logo,
  description,
  action,
  readMoreButton,
}) => {
  return (
    <article className={styles.banner}>
      {logo}
      <div className={styles.description}>
        <p className={styles.preamble}>{description}</p>
        {readMoreButton && <div className={styles.readMoreButton}>{readMoreButton}</div>}
      </div>
      {action && <div className={styles.action}>{action}</div>}
    </article>
  );
};
